import { render } from "./template.vue?vue&type=template&id=bc5e18f6&scoped=true"
import script from "./index.ts?vue&type=script&lang=js&external"
export * from "./index.ts?vue&type=script&lang=js&external"

import "./template.vue?vue&type=style&index=0&id=bc5e18f6&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc5e18f6"]])

export default __exports__